/* ProjectLemonade motion layer — PR-4.
   Sub-phase 4A: Lenis smooth scroll. */
(function () {
  'use strict';

  // Do not run inside Shopify theme editor iframe
  if (window.self !== window.top) return;

  // Respect reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Lenis init (library is injected via CDN in theme.liquid)
  if (typeof Lenis === 'undefined') {
    console.warn('[pl-motion] Lenis not loaded — skipping smooth scroll.');
    return;
  }

  var lenis = new Lenis({
    duration: 1.2,
    easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
    wheelMultiplier: 1.0,
    smoothTouch: false
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // Expose for later sub-phases to hook into scroll events
  window.__plLenis = lenis;
})();

/* Sub-phase 4B: word-by-word reveal on headings. */
(function () {
  'use strict';

  // Do not run inside Shopify theme editor iframe
  if (window.self !== window.top) return;

  var REVEAL_TARGETS = '.hero-title, .section-title';
  var WORD_STAGGER_MS = 45;

  function splitHeadingPreservingHTML(el) {
    if (el.dataset.plSplit === 'done') return;

    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var textNodes = [];
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim()) textNodes.push(node);
    }

    textNodes.forEach(function (textNode) {
      var parts = textNode.nodeValue.split(/(\s+)/);
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        if (/^\s+$/.test(part)) {
          frag.appendChild(document.createTextNode(part));
        } else if (part.length) {
          var span = document.createElement('span');
          span.className = 'pl-word';
          span.textContent = part;
          frag.appendChild(span);
        }
      });
      textNode.parentNode.replaceChild(frag, textNode);
    });

    el.dataset.plSplit = 'done';
  }

  function revealHeading(el) {
    if (el.dataset.plRevealed === 'done') return;
    var words = el.querySelectorAll('.pl-word');
    words.forEach(function (w, i) {
      w.style.transitionDelay = (i * WORD_STAGGER_MS) + 'ms';
    });
    el.classList.add('pl-revealed');
    el.dataset.plRevealed = 'done';
  }

  // Reduced motion: reveal everything instantly, no split needed
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll(REVEAL_TARGETS).forEach(function (el) {
      el.classList.add('pl-revealed');
    });
  } else {
    var headings = document.querySelectorAll(REVEAL_TARGETS);
    headings.forEach(splitHeadingPreservingHTML);

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          revealHeading(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3, rootMargin: '0px 0px -10% 0px' });

    headings.forEach(function (h) { io.observe(h); });
  }
})();

/* Sub-phase 4C: hero parallax + subtitle block fade. */
(function () {
  'use strict';

  if (window.self !== window.top) return;

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {

    // Subtitle block fade
    var subtitles = document.querySelectorAll('.hero-subtitle, .section-subtitle');
    var subIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pl-faded');
          subIO.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    subtitles.forEach(function (s) { subIO.observe(s); });

    // Hero parallax
    var heroBg = document.querySelector('.hero .hero-bg');
    if (heroBg) {
      var heroEl = heroBg.closest('.hero');
      var PARALLAX_SPEED = 0.15;
      var lastY = 0;

      function applyParallax(scrollY) {
        var rect = heroEl.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        heroBg.style.transform = 'translate3d(0, ' + (scrollY * PARALLAX_SPEED * -1) + 'px, 0)';
      }

      if (window.__plLenis) {
        window.__plLenis.on('scroll', function (e) { applyParallax(e.scroll); });
      } else {
        window.addEventListener('scroll', function () {
          if (lastY !== window.scrollY) {
            lastY = window.scrollY;
            requestAnimationFrame(function () { applyParallax(lastY); });
          }
        }, { passive: true });
      }
    }
  } else {
    // Reduced motion: subtitles appear immediately
    document.querySelectorAll('.hero-subtitle, .section-subtitle').forEach(function (s) {
      s.classList.add('pl-faded');
    });
  }
})();
